var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-read" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Cache Key"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("Okunacak cache key"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("Default Value (Cache bulunamazsa)"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t(
                "Cache bulunamazsa veya expire olduysa bu değer döndürülür"
              ),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.defaultValue,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "defaultValue", $$v)
              },
              expression: "clone.defaultValue",
            },
          }),
          _vm._v(" "),
          _vm._m(1),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "output-info" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "output-attributes" }, [
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v("block." + _vm._s("{") + "{'{blockId}'}}.value"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("Cache değeri veya default value")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v("block." + _vm._s("{") + "{'{blockId}'}}.found"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("Cache bulundu mu? (boolean)")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v("block." + _vm._s("{") + "{'{blockId}'}}.success"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("İşlem başarılı mı?")]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-text" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [_vm._v("Okumak istediğiniz cache'in key'ini girin.")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-text" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("lightbulb")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Cache bulunamazsa veya expire olduysa bu değer döndürülür. Boş bırakılırsa null döner."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("output")]),
      _vm._v(" "),
      _c("span", [_vm._v("Çıktı Bilgisi")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }